import React from 'react'

function CommonButton({ type, text, className, onClick, id, disable, }) {
    return (
        <div className='common_button'>
            <button onClick={onClick} type={type} className={className} id={id}>
                {text}
            </button>
        </div >
    )
}

export default CommonButton